export const tooltipWrapperConfig = {
    name: 'TooltipWrapper',
    category: 'Zapier Utilities',
    image: 'https://cdn.zappy.app/1c7ec1846b3e376d13e3fd10aa49a8ca.png',
    canHaveChildren: true,
    inputs: [
        {
            name: 'tooltipText',
            type: 'string',
        },
        {
            name: 'allowMultilineTooltip',
            type: 'boolean',
        },
        {
            name: 'isBlock',
            friendlyName: 'render as block',
            type: 'boolean',
            helperText: 'Indicates whether to render the component as a block level element.'
        },
        {
            name: 'position',
            type: 'string',
            enum: ['northwest', 'north', 'northeast', 'east', 'southeast', 'south', 'southwest', 'west', 'selfCorrecting'],
            defaultValue: 'selfCorrecting',
            helperText: 'Position of the tooltip.Use "selfCorrecting" to automatically correct the position if it overflows the viewport.'
        },
        {
            name: 'showTooltipOnTouchDevices',
            type: 'boolean',
        },
        {
            name: 'tooltipAriaHidden',
            type: 'boolean',
            defaultValue: true,
            helperText: 'This option decides if the tooltip is hidden from screen readers or not. By default, it is hidden to avoid repeating the content. If you set it to false, the tooltip can be read directly. This is handy when the element is not interactive.',
        },
    ],
};
//# sourceMappingURL=config.js.map